'use client'

import { ChangeEvent, useCallback, useState } from 'react'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import ErrorMessage from '../ErrorMessage/ErrorMessage'
import styles from './Textarea.module.scss'

type TextareaProps = UseControllerProps<FieldValues> & {
  label?: string
  maxCharacters?: number
  light?: boolean
  id: string
  placeholder: string
}

const Textarea = ({ label, maxCharacters, control, name, rules }: TextareaProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules })
  const [charactersLeft, setCharactersLeft] = useState(maxCharacters)

  const updateCharactersLeft = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => {
      const textarea = document.getElementById(name)
      if (textarea) {
        textarea.style.height = 'auto'
        textarea.style.height = textarea.scrollHeight + 'px'
      }

      if (maxCharacters) {
        const currentCharactersLength = e.currentTarget.value.length ?? 0
        setCharactersLeft(maxCharacters - currentCharactersLength)
      }

      field.onChange(e)
    },
    [field, maxCharacters, name]
  )

  return (
    <div className={styles.container}>
      <textarea id={name} maxLength={maxCharacters} rows={1} className={error && styles.error} placeholder=' ' {...field} onChange={updateCharactersLeft} />

      <label htmlFor={name}>{label}</label>

      <ErrorMessage error={error} />

      <span className={styles.counter}>{charactersLeft} characters left</span>
    </div>
  )
}

export default Textarea
